import Vue from 'vue'
import Router from 'vue-router'
import car from '@/pages/car/carInfo/index'
import Order from '@/pages/Order/Order'
import Clause from '@/pages/car/clause/index'
import Confirm from '@/pages/car/confirm/index'
import PayStatus from '@/pages/car/payStatus/index'
import ModelQuery from '@/pages/car/modelQuery/index'
import InstructionsForInsurance from '@/pages/car/InstructionsForInsurance/index'
import InsuranceClauses from '@/pages/car/InsuranceClauses/index'
import Vehicle from '@/pages/car/vehicle/index'
import Relate from '@/pages/car/relate/index'
import NewQuote from '@/pages/car/newQuote/index'
import Supplementary from '@/pages/car/supplementary/index'
import OldSupplementary from '@/pages/car/supplementaryOld/index'// 老核保页面
import PlatformInformation from '@/pages/car/PlatformInformation/PlatformInformation'
import Pdf from '@/pages/Pdf/Pdf'
import PdfDown from '@/pages/Pdf/PdfDown/PdfDown'
import ElePolicy from '@/pages/Pdf/elePolicy/index'
import ImgCon from '@/pages/Pdf/imgCon/imgCon'
import Error from '@/pages/401/401'
import ShareQuote from '@/pages/ShareQuote/ShareQuote'
import ElectronicPolicy from '@/pages/car/confirm/ElectronicPolicy.vue'
// const Pdf = () => import("@/pages/Pdf/Pdf")
// const imgCon = () => import("@/pages/Pdf/imgCon/imgCon")
import More from '@/pages/More/More.vue'
import Change from '@/pages/Info/Change.vue'
import Break from '@/pages/Info/Break.vue'
import Tips from '@/pages/Tips/Tips.vue'

// 摩托车险
import motor from '@/pages/motor/index.vue'
import baseInfo from '@/pages/motor/components/baseInfo/index.vue'
import personInfo from '../pages/motor/components/personInfo/index.vue'
import personFace from '../pages/motor/components/personInfo/personFace/index.vue'
import motorQuote from '../pages/motor/components/quote/index.vue'
import motorSupplementary from '../pages/motor/components/supplementary/index.vue'
import motorClause from '../pages/motor/components/supplementary/motorClause/index.vue'
import insuredSuccess from '../pages/motor/components/insuredSuccess/index.vue'
import carModelList from '../pages/motor/components/baseInfo/components/carModelList.vue'
import motorLogin from '../pages/motor/components/motorLogin/index.vue'
import agreement from '../pages/motor/components/motorLogin/components/agreement.vue'
import perfectPersonalInfo from '../pages/motor/components/motorLogin/components/perfectPersonalInfo/perfectPersonalInfo.vue'
import registeredUsers from '../pages/motor/components/motorLogin/components/registeredUsers/registeredUsers.vue'
import confirm from '../pages/motor/components/confirm/confirm.vue'
import OrderList from '../pages/motor/components/orderList/orderList.vue'

Vue.use(Router)

const originalPush = Router.prototype.push
// 修改 原型对象中的push方法
Router.prototype.push = function push(location, resolve, reject) {
  // return originalPush.call(this, location).catch(err => err)
  if (resolve && reject) {
    originalPush.call(this, location, resolve, reject)
  } else {
    originalPush.call(this, location, () => {}, () => {})
  }
}
const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/Loading' // 首页
    }, {
      path: '/car/Confirm',
      name: 'Confirm',
      component: Confirm
    }, {
      path: '/car/ElectronicPolicy', // 电子保单
      name: 'ElectronicPolicy',
      component: ElectronicPolicy
    }, {
      path: '/car/InstructionsForInsurance',
      name: 'InstructionsForInsurance',
      component: InstructionsForInsurance // 投保须知
    }, {
      path: '/car/InsuranceClauses',
      name: 'InsuranceClauses',
      component: InsuranceClauses // 保险条款
    }, {
      path: '/car',
      component: car,
      redirect: '/car/Vehicle',
      children: [
        { path: 'vehicle', name: 'Vehicle', component: Vehicle },
        { path: 'relate', name: 'Relate', component: Relate },
        { path: 'supplementary', name: 'Supplementary', component: Supplementary },
        { path: 'OldSupplementary', name: 'OldSupplementary', component: OldSupplementary },
        { path: 'modelQuery', name: 'ModelQuery', component: ModelQuery },
        { path: 'clause', name: 'Clause', component: Clause },
        { path: 'PayStatus', name: 'PayStatus', component: PayStatus },
        { path: 'PlatformInformation', name: 'PlatformInformation', component: PlatformInformation },
        { path: 'newQuote', name: 'NewQuote', component: NewQuote }
      ]
    }, {
      path: '/Order',
      name: 'Order',
      component: Order // 订单
    }, {
      path: '/Pdf',
      name: 'Pdf',
      component: Pdf // pdf预览
    },
    {
      path: '/PdfDown',
      name: 'PdfDown',
      component: PdfDown // pdf预览紫属保紫易保
    },
    {
      path: '/elePolicy',
      name: 'ElePolicy',
      component: ElePolicy // 紫属保电子投保单
    },
    {
      path: '/imgCon',
      name: 'imgCon',
      component: ImgCon // pdf预览紫属保紫易保
    },
    {
      path: '/401',
      name: 401,
      component: Error // c端token失效
    }, {
      path: '/shareQuote',
      name: 'ShareQuote',
      component: ShareQuote // 分享报价页
    },
    {
      path: '/more',
      name: 'more',
      component: More // 详情
    },
    {
      path: '/change',
      name: 'change',
      component: Change // 详情
    },
    {
      path: '/break',
      name: 'break',
      component: Break // 详情
    },
    {
      path: '/tips',
      name: 'tips',
      component: Tips // 详情
    },
    {
      path: '/middleware',
      name: 'middleware',
      component: () => import('@/pages/middleware/index.vue'),
      meta: {
        title: '健康问询'
      } // 详情
    },
    {
      path: '/motor',
      component: motor,
      redirect: '/motor/baseInfo',
      meta: {
        title: '摩托车险'
      },
      children: [
        { path: 'baseInfo',
          name: 'BaseInfo',
          component: baseInfo,
          meta: {
            title: '摩托车险'
          }
        },
        { path: 'personInfo',
          name: 'PersonInfo',
          component: personInfo,
          meta: {
            title: '摩托车险'
          }
        },
        { path: 'personFace',
          name: 'personFace',
          component: personFace,
          meta: {
            title: '人员信息'
          }
        }, // 人脸识别页面
        { path: 'motorQuote',
          name: 'MotorQuote',
          component: motorQuote,
          meta: {
            title: '摩托车险'
          }
        },
        { path: 'motorSupplementary',
          name: 'MotorSupplementary',
          component: motorSupplementary,
          meta: {
            title: '摩托车险'
          }
        },
        { path: 'carModelList',
          name: 'carModelList',
          component: carModelList,
          meta: {
            title: '车型列表'
          }
        },
        {
          path: 'motorClause',
          name: 'motorClause',
          component: motorClause,
          meta: {
            title: '摩托车特约'
          }
        }
      ]
    },
    { path: '/motor/motorLogin',
      name: 'MotorLogin',
      component: motorLogin,
      meta: {
        title: '摩托车险登录'
      }
    },
    { path: '/motor/agreement',
      name: 'Agreement',
      component: agreement,
      meta: {
        title: '摩托车险登录协议'
      }
    },
    { path: '/motor/perfectPersonalInfo',
      name: 'PerfectPersonalInfo',
      component: perfectPersonalInfo,
      meta: {
        title: '摩托车险首次登录校验'
      }
    },
    { path: '/motor/registeredUsers',
      name: 'RegisteredUsers',
      component: registeredUsers,
      meta: {
        title: '摩托车险完善个人校验'
      }
    },
    {
      path: '/motor/insuredSuccess',
      name: 'InsuredSuccess',
      component: insuredSuccess,
      meta: {
        title: '紫金摩托车险'
      }
    },
    {
      path: '/motor/orderList',
      name: 'orderList',
      component: OrderList,
      meta: {
        title: '紫金摩托车险'
      }
    },
    {
      path: '/motor/confirm',
      name: 'motorConfirm',
      component: confirm,
      meta: {
        title: '订单详情'
      }
    }

  ]
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('setToken')
  const setMotorCode = localStorage.getItem('setMotorCode')
  if (to.path.includes('/motor')) {
    console.log(token, 'token')
    console.log(setMotorCode, 'setMotorCode')
    // console.log(!token && to.path!=='/motor/motorLogin');
    if (to.path === '/motor/agreement') {
      next()
    } else if (!token && to.path !== '/motor/motorLogin' && to.path !== '/motor/perfectPersonalInfo' && to.path !== '/motor/registeredUsers') {
      if (setMotorCode === 'SHAAN_XICode') {
        next('/motor/motorLogin?areaName=SHAAN_XI')
      } else if (setMotorCode === 'HE_BEICode') {
        next('/motor/motorLogin?areaName=HE_BEI')
      } else if (setMotorCode === 'HE_BEI_02Code') {
        next('/motor/motorLogin?areaName=HE_BEI_02')
      } else if (setMotorCode === 'FU_JIANCode') {
        next('/motor/motorLogin?areaName=FU_JIAN')
      } else if (setMotorCode === 'NING_BOCode') {
        next('/motor/motorLogin?areaName=NING_BO')
      } else if (setMotorCode === 'XIA_MENCode') {
        next('/motor/motorLogin?areaName=XIA_MEN')
      } else if (setMotorCode === 'SHAN_XICode') {
        next('/motor/motorLogin?areaName=SHAN_XI')
      } else if (setMotorCode === 'HU_NANCode') {
        next('/motor/motorLogin?areaName=HU_NAN')
      } else {
        next('/motor/motorLogin')
      }
    } else {
      next()
    }
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js